import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// root state object.
// each Vuex instance is just a single state tree.
const state = {
  currentTab: 'home'
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  changeTab(state, tabName) {
    state.currentTab = tabName;
  }
}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
  initTabName: ({ commit }, tabName) => commit('changeTab', tabName)
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  state,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js